module.exports = __webpack_public_path__ + "static/media/comments-icon.70aa6334.svg";